import {useCallback} from 'react';
import utils from 'helpers/utils';
import {useViewUpdate} from 'services/view/view.hooks';

export function useViewPatch () {
  const viewUpdate = useViewUpdate();

  return useCallback((view, changes) => {
    changes = (Object.keys(changes).length > 1) ? utils.changedFormFields(view, changes) : changes;

    if (!utils.isEmpty(changes)) {
      return viewUpdate.mutation.mutateAsync({
        viewId: view.viewId,
        ...changes
      });
    } else {
      return Promise.resolve();
    }
  }, [viewUpdate.mutation]);
}
